<template>
	<div>
		<div class="cs-head">
			<div><h1 class="cs-title">My quotes</h1><p class="cs-sub">Your quotes, their status in plain words, and what to do next.</p></div>
			<div class="row"><router-link class="btn-primary" to="/pricing"><i class="fa-solid fa-plus"></i> New quote</router-link></div>
		</div>
		<pe-toolbar v-model="search" placeholder="Search account" :pills="pills" :active-pills="[pill]" :show-filters="false" :show-columns="false" @pill="setPill" />
		<div class="tbl-scroll">
			<table class="tbl nochk">
				<thead><tr><th class="sticky-l2">Account</th><th class="r">Price</th><th>Status</th><th>What to do</th><th>Updated</th><th class="end"></th></tr></thead>
				<tbody v-if="!loading">
					<tr v-for="r in rows" :key="r.id" class="rowable" @click="open(r)">
						<td class="sticky-l2"><div class="acct"><span class="avatar">{{ initials(r.account) }}</span><span><span class="acct-name">{{ r.account }}<template v-if="r.state_abb">, {{ r.state_abb }}</template></span><span class="sub">{{ [r.prospect_type ? entityLabel(r.prospect_type) : '', r.context].filter(Boolean).join(' · ') }}</span></span></div></td>
						<td class="r num">{{ money(r.annual_net_cents) }} a year<template v-if="r.one_time_net_cents"> + {{ money(r.one_time_net_cents) }} once</template></td>
						<td><pe-status :tone="tone(r.next_step.status)" :label="r.next_step.status" /></td>
						<td class="wrap muted">{{ r.next_step.action }}</td>
						<td class="faint">{{ fmtDate(r.updated_at) }}</td>
						<td class="end"></td>
					</tr>
					<tr v-if="!rows.length" class="empty"><td colspan="6"><i class="fa-regular fa-folder-open"></i><div>No quotes here.</div></td></tr>
				</tbody>
				<tbody v-else><tr v-for="n in 5" :key="n" class="skeleton"><td colspan="6"><span class="sk"></span></td></tr></tbody>
			</table>
		</div>
	</div>
</template>

<script>
import restApi from '../../api/index.js'
import { PeToolbar, PeStatus } from '../../components/pe'
import { money, fmtDate, initials } from './pe-util'
import { entityLabel } from '../../utils/entity'

const GROUPS = { all: null, action: ['draft', 'waiting_inputs', 'decision', 'sent'], finance: ['ready_for_finance', 'blocked'], done: ['sent', 'closed'] } // decided: back with sales to send

export default {
	name: 'PricingMyQuotes',
	components: { PeToolbar, PeStatus },
	data() { return { all: [], loading: false, search: '', pill: 'all' } },
	computed: {
		pills() {
			const n = k => this.all.filter(r => !GROUPS[k] || GROUPS[k].includes(r.state)).length
			return [{ value: 'all', label: 'All', count: n('all'), tone: 'grey' }, { value: 'action', label: 'Needs my action', count: n('action'), tone: 'blue' }, { value: 'finance', label: 'Waiting on finance', count: n('finance'), tone: 'amber' }, { value: 'done', label: 'Sent or won', count: n('done'), tone: 'green' }]
		},
		rows() {
			const q = this.search.trim().toLowerCase()
			return this.all.filter(r => (!GROUPS[this.pill] || GROUPS[this.pill].includes(r.state)) && (!q || r.account.toLowerCase().includes(q) || (r.context || '').toLowerCase().includes(q)))
		},
	},
	created() {
		this.loading = true
		restApi.get('/pricing/quotes/mine', { params: { perPage: 200 } }).then(({ data }) => { this.all = data.data }).catch(() => {}).finally(() => { this.loading = false })
	},
	methods: {
		money, fmtDate, initials, entityLabel,
		setPill(v) { this.pill = v },
		tone(status) { return { Draft: 'grey', 'Waiting for finance': 'amber', 'Ready to send': 'blue', Sent: 'green', Won: 'green', Lost: 'red', Expired: 'red', Closed: 'grey' }[status] || 'grey' },
		open(r) { this.$router.push('/pricing/quotes/' + r.id + (['draft', 'waiting_inputs'].includes(r.state) ? '/build' : '/send')) },
	},
}
</script>
